import { render, staticRenderFns } from "./FrotoMigrationTable.vue?vue&type=template&id=72a6ff5e&scoped=true&"
import script from "./FrotoMigrationTable.vue?vue&type=script&lang=js&"
export * from "./FrotoMigrationTable.vue?vue&type=script&lang=js&"
import style0 from "./FrotoMigrationTable.vue?vue&type=style&index=0&id=72a6ff5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6ff5e",
  null
  
)

export default component.exports